<template>
  <div class="container m-t-30">
    <div
      v-if="showLoading"
      class="loading"
    >
      <unc-loader />
    </div>

    <div
      v-else
      class="row"
    >
      <div class="col-md-3 col-sm-2 col-xs-12" />

      <div class="col-md-6 col-sm-8 col-xs-12">
        <div v-if="currentComponent == 'register-search'">
          <register-search />
        </div>

        <div v-else-if="currentComponent == 'register-search-results'">
          <register-search-results />
        </div>

        <div v-else-if="currentComponent == 'register-person-rol'">
          <register-person-rol />
        </div>

        <div v-else-if="currentComponent == 'register-person-form'">
          <register-person-form />
        </div>
      </div>

      <div class="col-md-3 col-sm-2 col-xs-12" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import registerPersonForm from './register-person-form.vue';
import registerPersonRol from './register-person-rol.vue';
import registerSearchResults from './register-search-results.vue';
import registerSearch from './register-search.vue';

export default {
    name: 'RegisterLayout',
    components: {
        registerSearch,
        registerSearchResults,
        registerPersonRol,
        registerPersonForm,
    },
    computed: mapState([
        'currentComponent',
        'showLoading',
    ]),
    watch: {
        currentComponent (current, previous) {
            if (previous) this.focusStepTitle();
        },
    },
    mounted () {
        this.$store.commit('setCurrentComponent', 'register-search');
    },
    beforeDestroy () {
        this.stopStepTitleObserver();
    },
    methods: {
        // El cambio de paso no navega: el foco va al título del paso, que aparece después de su loader.
        focusStepTitle () {
            this.stopStepTitleObserver();

            const tryFocus = () => {
                const title = this.showLoading ? null : this.$el.querySelector('.register-title');
                if (!title) return false;

                this.stopStepTitleObserver();
                title.setAttribute('tabindex', '-1');
                title.focus({ preventScroll: true });
                return true;
            };

            this.$nextTick(() => {
                if (tryFocus() || typeof MutationObserver === 'undefined') return;

                this.stepTitleObserver = new MutationObserver(tryFocus);
                this.stepTitleObserver.observe(this.$el, { childList: true, subtree: true });
            });
        },
        stopStepTitleObserver () {
            if (!this.stepTitleObserver) return;

            this.stepTitleObserver.disconnect();
            this.stepTitleObserver = null;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
